(function() {

    'use strict';

    angular.module('app').config(apiAccessUrlConfig);

    apiAccessUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function apiAccessUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/api-access/view/:id', {
            templateUrl: '/templates/pages/api-access/view.html',
            controller: 'ApiAccessViewController',
            controllerAs: 'vm',
            params: {
                parent: 'api-access',
                htmlTitle: 'API Access',
                pageTitle: 'API Access'
            }
        })
        .when('/api-access/third-party-accounting-app', {
            templateUrl: '/templates/pages/api-access/third-party-accounting-apps.html', 
            controller: 'ThirdPartyAccountingApp',
            controllerAs: 'vm', 
            params: {
                name: 'third-party-accounting-apps',
                parent: 'api-access', 
                htmlTitle: 'API Access', 
                pageTitle: 'API Access'
            }
        })
        .when('/api-access/accounting-app-details/:id', {
            templateUrl: '/templates/pages/api-access/third-party-accounting-app-details.html',
            controller: 'ThirdPartyAccountingAppDetailsController',
            controllerAs: 'vm', 
            params: {
                parent: 'api-access',
                subParent: 'thirdPartyAccountingApp', 
                htmlTitle: 'Accounting App Details', 
                pageTitle: 'Accounting App Details'
            }
        });
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();


// WEBPACK FOOTER //
// ./js/urls/api-access.js